import { Divider, Stack, Typography, Box } from "@mui/material";
import { ReactElement } from "react";
import InfoIcon from "../../../components/misc/InfoIcon";

interface CenteredBoxBaseProps {
  icon: ReactElement;
  title: ReactElement;
}

interface CenteredBoxRangeProps extends CenteredBoxBaseProps {
  range: { start: string; end: string };
  value?: never; 
}

interface CenteredBoxValueProps extends CenteredBoxBaseProps {
  value: string;
  range?: never; 
}
type CenteredBoxProps = CenteredBoxRangeProps | CenteredBoxValueProps;

interface WithInfoIconProps {
  id?: string;
  showInfoIcon?: boolean;
  onInfoClick?: () => void;
  infoIconProps?: {
    textColor?: string;
    backgroundColor?: string;
    size?: number;
    fontSize?: number;
  };
}

type CenteredBoxWithInfoProps = CenteredBoxProps & WithInfoIconProps;

const CenteredBox: React.FC<CenteredBoxWithInfoProps> = ({
  icon,
  title,
  range,
  value,
  showInfoIcon,
  onInfoClick,
  infoIconProps,
  id
}) => {
  return (
    <Box id={id} position="relative" width="100%" height="100%">
      <Stack
        width="100%"
        height={250}
        alignItems="center"
        justifyContent="center"
        spacing={3}
        sx={{ position: 'relative' }}
      >
        {showInfoIcon && onInfoClick && (
          <Box
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              zIndex: 1,
              pointerEvents: 'auto'
            }}
          >
            <InfoIcon
              onClick={onInfoClick}
              textColor={infoIconProps?.textColor}
              backgroundColor={infoIconProps?.backgroundColor}
              size={infoIconProps?.size}
              fontSize={infoIconProps?.fontSize}
            />
          </Box>
        )}
        <Stack alignItems="center" justifyContent="center" spacing={1}>
          <Typography color="success">{icon}</Typography>
          {title}
          <Divider orientation="horizontal" sx={{ width: "100%" }} />
        </Stack>
        {value ? (
          <Typography variant="h4" m={0} color="success">
            {value}
          </Typography>
        ) : (
          <Stack
            direction="row"
            spacing={2}
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="h4" color="success">
              {range!.start}
            </Typography>
            <Typography variant="h4" color="success">
              -
            </Typography>
            <Typography variant="h4" color="success">
              {range!.end}
            </Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
}


export default CenteredBox;
